module.exports = __webpack_public_path__ + "img/russel-large.d7a83b76.png";